import Modal from "react-bootstrap/Modal";
import "../../styles/org-buttons.css";
import { buttonText } from "../../utils/buttonText";
import { notificationText } from "../../utils/notificationText";

function DeleteDoudleConfirmModal(props) {
  const {
    item,
    datasetName,
    isTrashGroup,
    show,
    onHide,
    deleteMethod,
    onDelete,
    onDeleteSelected,
    resetDeleteMethod,
  } = props;

  const canDelete = !item || (item.folder !== "Yes" && item.table !== "Yes");

  const handleDoubleConfirm = () => {
    if (datasetName) {
      onDelete(item);
    } else if (deleteMethod && deleteMethod === "deleteSelected") {
      onDeleteSelected();
    } else if (deleteMethod === "deleteAll") {
      onDelete();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton closeLabel={buttonText("Close")}>
        <Modal.Title id="contained-modal-title-vcenter">
          {notificationText("Delete Dataset")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {canDelete ? (
          deleteMethod === "deleteAll" || isTrashGroup ? (
            <p>
              {notificationText(
                "Data cannot be recovered after deletion, please proceed with caution."
              )}
            </p>
          ) : !isTrashGroup ? (
            <p>
              {notificationText(
                "The dataset will be transferred to the Trash, please check whether to execute the task."
              )}
            </p>
          ) : null
        ) : (
          <p>
            {notificationText(
              "Dataset that represents a folder/table can not be deleted here, please delete them in folder/table page instead."
            )}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className="org-modal-footer">
        <button type="button" className="org-btn org-btn-secondary" onClick={onHide}>
          {buttonText("Cancel")}
        </button>
        {canDelete && (
          <button
            type="button"
            className="org-btn org-btn-danger"
            onClick={() => {
              onHide();
              handleDoubleConfirm();
              resetDeleteMethod();
            }}
          >
            {buttonText("Delete")}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteDoudleConfirmModal;
